import { render, staticRenderFns } from "./WorkIconOrganizationElement.vue?vue&type=template&id=dde685f8"
import script from "./WorkIconOrganizationElement.vue?vue&type=script&lang=js"
export * from "./WorkIconOrganizationElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports